import "./App.css"
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom"
import { Login } from "./pages/login"
import { LoadingProvider } from "./context/loading"
import { ToastProvider } from "./context/toast"
import { CreditsProvider } from "./context/credits"
import { EntitlementsProvider } from "./context/entitlements"
import { PageNotFound } from "./pages/pageNotFound"
import { Home } from "./pages/home"
import { MainLayout } from "./components/mainLayout"
import { ProtectedRoute } from "./components/protectedRoute"
import { CandidatePage } from "./pages/candidate"
import { JobPage } from "./pages/job"
import { SettingsPage } from "./pages/settings"
import { SettingsUpdatePage } from "./pages/settings-update"
import { SignupPage } from "./pages/signup"
import { CandidatesPage } from "./pages/candidates"
import { Jobs } from "./pages/jobs"
import { EventsPage } from "./pages/events"
import { EventDetailsPage } from "./pages/eventDetails"
import { EventFormPage } from "./pages/eventForm"
import { CreditsPage } from "./pages/credits"
import { ApplicationCandidatePage } from "./pages/applicationCandidate"
import { NotificationsPage } from "./pages/notifications"
import { ForgotPasswordPage } from "./pages/forgotPassword"
import { VerifyEmailPage } from "./pages/verify-email"
import { CookieBanner } from "./components/cookieBanner"
import "font-awesome/css/font-awesome.min.css"

function App() {
  return (
      <div className="App relative m-auto max-w-[1600px]">
        <CookieBanner />
        <LoadingProvider>
          <ToastProvider>
          <CreditsProvider>
          <EntitlementsProvider>
          <Router>
            <Routes>
              <Route path="*" element={<PageNotFound />} />
              <Route path="/" element={<Login />} />
              <Route path="/signup" element={<SignupPage />} />
              <Route path="/verify-email" element={<VerifyEmailPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />

              <Route element={<ProtectedRoute />}>
              <Route element={<MainLayout />}>
                <Route path="/home" element={<Home />} />
                <Route path="/candidates/:id" element={<CandidatePage />} />
                <Route path="/job/:id" element={<JobPage />} />
                <Route path="/candidates" element={<CandidatesPage />} />
                <Route path="/applications/:id" element={<ApplicationCandidatePage />} />
                <Route path="/notifications" element={<NotificationsPage />} />
                <Route path="/post-job" element={<JobPage />} />
                <Route path="/job" element={<JobPage />} />
                <Route path="/jobs" element={<Jobs />} />
                <Route path="/events" element={<EventsPage />} />
                <Route path="/events/new" element={<EventFormPage />} />
                <Route path="/events/:id/edit" element={<EventFormPage />} />
                <Route path="/events/:id" element={<EventDetailsPage />} />
                <Route path="/settings" element={<SettingsPage />} />
                <Route path="/settings/update" element={<SettingsUpdatePage />} />
                {/* Abonamentele s-au unificat în hub-ul Planuri & Credite. */}
                <Route path="/subscription" element={<Navigate to="/credits" replace />} />
                <Route path="/credits" element={<CreditsPage />} />
              </Route>
              </Route>
            </Routes>
          </Router>
          </EntitlementsProvider>
          </CreditsProvider>
          </ToastProvider>
        </LoadingProvider>
      </div>
  )
}

export default App